import { render, staticRenderFns } from "./form-task-category.vue?vue&type=template&id=5f814d3f&"
import script from "./form-task-category.vue?vue&type=script&lang=js&"
export * from "./form-task-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f814d3f')) {
      api.createRecord('5f814d3f', component.options)
    } else {
      api.reload('5f814d3f', component.options)
    }
    module.hot.accept("./form-task-category.vue?vue&type=template&id=5f814d3f&", function () {
      api.rerender('5f814d3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configuration/task/form-task-category.vue"
export default component.exports